import React from "react";
import btc from "./images/btc.png";
import bch from "./images/bch.png";
import eth from "./images/eth.png";
import ltc from "./images/ltc.png";
import coins from "./images/coins.png";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Input from "@material-ui/core/Input";
import InputAdornment from "@material-ui/core/InputAdornment";
import Button from "@material-ui/core/Button";
import "./styles/Payment.css";
import URL from '../constants/url';

import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import RadioButtonCheckedIcon from "@material-ui/icons/RadioButtonChecked";
import Spinner from "react-md-spinner";

const axios = require("axios");

class Payment extends React.Component {
  state = {
    expanded: null,
    // expanded: "panel3",
    amount: null,
    coinbase: {
      disabled: null,
      loading: false
    },
    paypal: {
      loading: false
    },
    selectedValue: "5"
  };

  handleChange = panel => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false
    });
  };

  handleAmountChange = e => {
    // console.log(e.target.value);
    this.setState({
      amount: e.target.value
    });
  };

  handleRadioChange = event => {
    this.setState({ selectedValue: event.target.value });
  };

  handleCoinbase = () => {
    this.setState({
      coinbase: {
        loading: true,
        disabled: true
      }
    });
    let query = {};
    query["uid"] = this.props.uid;
    query["amount"] = this.state.amount.toString();
    // console.log(query);
    axios
      .post(URL+ "/invoice/create/coinbase", query)
      .then(response => {
        window.location = response.data.url;
      });
    // console.log(this.state);
  };

  handlePaypal = () => {
    this.setState({
      paypal: {
        loading: true
      }
    });
    let query = {};
    query["email"] = this.props.email;
    query["amount"] = this.state.amount.toString();

    axios
      .post(URL+ "/invoice/create/paypal", query)
      .then(response => {
        window.location = response.data.url;
      });
  };

  render() {
    const { expanded } = this.state;

    return (
      <div>
        <div className="baslik">
          <i className="material-icons">add_box</i>
          <h4>Top-up Balance</h4>
        </div>

        <div className="d-flex flex-wrap">
          <div className="col-10 col-sm-6 col-lg-3" id="inputCol">
            <FormControl fullWidth id="topupInput">
              <InputLabel htmlFor="adornment-amount">Amount</InputLabel>
              <Input
                id="adornment-amount"
                value={this.state.amount}
                onChange={this.handleAmountChange.bind(this)}
                startAdornment={
                  <InputAdornment position="start">$</InputAdornment>
                }
              />
            </FormControl>
            <Button
              variant="contained"
              // color="primary"
              id="adornment-btn"
              style={{backgroundColor:"#6DBAA1",color:"white"}}
              onClick={() => {
                if (this.state.amount) {
                  this.setState({
                    expanded: "panel1"
                  });
                }
              }}
            >
              <i className="material-icons">add</i>
              Add
            </Button>
            <br />
            <p style={{ color: "mediumvioletred" }}>
              {this.state.amount && this.state.amount < 1
                ? "Minimum payment is $1"
                : ""}
            </p>
          </div>

          <div className="col-10 col-sm-6 col-lg-6" id="paymentBox">
            <ExpansionPanel
              expanded={expanded === "panel1"}
              disabled={!this.state.amount || this.state.amount < 1}
              onChange={this.handleChange("panel1")}
            >
              <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                <Typography className="heading">
                  {/* Coinbase */}
                  <img
                    src="http://mdvsoft.at/images/coinbaselogo.png"
                    height="30px"
                  />
                </Typography>
                <div>
                  <Typography className={"classes.secondaryHeading"}>
                    {/* Pay using Bitcon, Ethereum, Litecoin and Bitcoin Cash */}
                    <span className="badge badge-success">No Fee!</span>
                  </Typography>
                </div>
                <div style={{ marginLeft: "50px" }}>
                  <img src={coins} height="30px" />
                </div>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails
                style={{ flexWrap: "wrap", justifyContent: "flex-end" }}
              >
                {/* Nulla facilisi. Phasellus sollicitudin nulla et quam mattis
                  feugiat. Aliquam eget maximus est, id dignissim quam. */}
                <table className="table">
                  <tbody>
                    <tr>
                      <td>Top-up Amount:</td>
                      <td>$ {this.state.amount}</td>
                    </tr>
                    <tr>
                      <td>Gateway fee:</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>Total due:</td>
                      <td>$ {this.state.amount}</td>
                    </tr>
                  </tbody>
                </table>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={this.handleCoinbase}
                  disabled={!!this.state.coinbase.disabled}
                >
                  <i
                    className={
                      "fa fa-circle-o-notch fa-spin " +
                      (this.state.coinbase.loading ? "" : "notLoading")
                    }
                  />
                  Pay with Coinbase
                </button>
              </ExpansionPanelDetails>
            </ExpansionPanel>
            <ExpansionPanel
              expanded={expanded === "panel2"}
              disabled={!this.state.amount || this.state.amount < 1}
              onChange={this.handleChange("panel2")}
            >
              <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                <Typography className="heading">
                  {/* Credit Card */}
                  <img
                    src="http://www.pngmart.com/files/3/Credit-Card-Visa-And-Master-Card-PNG-HD.png"
                    height="25px"
                  />
                </Typography>
                <Typography className={"classes.secondaryHeading"}>
                  {/* You are currently not an owner */}
                </Typography>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails
                style={{ flexWrap: "wrap", justifyContent: "flex-end" }}
              >
                <table className="table">
                  <tbody>
                    <tr>
                      <td>Top-up Amount:</td>
                      <td>$ {this.state.amount}</td>
                    </tr>
                    <tr>
                      <td>Gateway fee:</td>
                      <td>$0.30</td>
                    </tr>
                    <tr>
                      <td>Total due:</td>
                      <td>$ {parseInt(this.state.amount) + 0.3}</td>
                    </tr>
                  </tbody>
                </table>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                    alert(
                      "Sorry, We are still working on it\nYou can use other payment gateways instead."
                    );
                    this.setState({
                      expanded: "panel1"
                    });
                  }}
                >
                  Pay with Credit Card
                </button>
              </ExpansionPanelDetails>
            </ExpansionPanel>
            <ExpansionPanel
              expanded={expanded === "panel3"}
              disabled={!this.state.amount || this.state.amount < 1}
              onChange={this.handleChange("panel3")}
            >
              <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                <Typography className="heading">
                  {/* Paypal */}
                  <img
                    src="http://imgim.com/rsz_paypal-784404_960_720.png"
                    height="25px"
                  />
                </Typography>
                <Typography className={"classes.secondaryHeading"}>
                  {/* Filtering has been entirely disabled for whole web server */}
                </Typography>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails
                style={{ flexWrap: "wrap", justifyContent: "flex-end" }}
              >
                <table className="table">
                  <tbody>
                    <tr>
                      <td>Top-up Amount:</td>
                      <td />
                      <td>$ {this.state.amount}</td>
                    </tr>
                    <tr>
                      <td>Gateway fee:</td>
                      <td />
                      <td>$0.30</td>
                    </tr>
                    <tr>
                      <td>Total due:</td>
                      <td />
                      <td>$ {parseInt(this.state.amount) + 0.3}</td>
                    </tr>
                  </tbody>
                </table>
                <div>
                  <Spinner
                    style={{ marginRight: "5px" }}
                    singleColor="#03a9f4"
                    className={this.state.paypal.loading ? "" : "notLoading"}
                  />
                  <img
                    id="paypalBtn"
                    className={this.state.paypal.loading ? "halfOpacity" : ""}
                    src="https://woocommerce.com/wp-content/uploads/2016/04/PayPal-Express@2x.png"
                    onClick={this.state.amount >= 1 ? this.handlePaypal : null}
                    disabled
                  />
                </div>
              </ExpansionPanelDetails>
            </ExpansionPanel>
          </div>
        </div>
      </div>
    );
  }
}

export default Payment;

/*
<tr>
                      <td colSpan="5">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between"
                          }}
                        >
                          <FormControlLabel
                            // style={{marginLeft:"5px"}}
                            control={
                              <Radio
                                checked={this.state.selectedValue === "1"}
                                onChange={this.handleRadioChange}
                                value="1"
                                color="default"
                                name="radio-button-demo"
                                aria-label="D"
                              />
                            }
                            label="$1"
                          />

                          <FormControlLabel
                            control={
                              <Radio
                                checked={this.state.selectedValue === "3"}
                                onChange={this.handleRadioChange}
                                value="3"
                                color="default"
                                name="radio-button-demo"
                                aria-label="D"
                              />
                            }
                            label="$3"
                          />

                          <FormControlLabel
                            control={
                              <Radio
                                checked={this.state.selectedValue === "5"}
                                onChange={this.handleRadioChange}
                                value="5"
                                color="default"
                                name="radio-button-demo"
                                aria-label="D"
                              />
                            }
                            label="$5"
                          />

                          <FormControlLabel
                            control={
                              <Radio
                                checked={this.state.selectedValue === "10"}
                                onChange={this.handleRadioChange}
                                value="10"
                                color="default"
                                name="radio-button-demo"
                                aria-label="D"
                              />
                            }
                            label="$10"
                          />

                          <FormControlLabel
                            control={
                              <Radio
                                checked={this.state.selectedValue === "20"}
                                onChange={this.handleRadioChange}
                                value="20"
                                color="default"
                                name="radio-button-demo"
                                aria-label="D"
                              />
                            }
                            label="$20"
                          />
                        </div>
                      </td>
                    </tr>
                    */
